import { makeLegendFormatter } from '../utils/legend-formatter.js'
import { dateFormatterInit } from '../utils/date-formatter.js'

const pmChartOptions = {
  height: 320,
  labels: [
    'Datetime',
    'PM 2.5',
    'PM 4.0',
    'PM 10.0'
  ],
  series: {
    'PM 2.5': {
      axis: 'y'
    },
    'PM 4.0': {
      axis: 'y'
    },
    'PM 10.0': {
      axis: 'y'
    }
  },
  axes: {
    x: dateFormatterInit(),
    y: {
      valueRange: [0, null],
      axisLabelWidth: 50,
      independentTicks: true,
      axisLabelFormatter: (y) => y.toFixed(1)
    }
  },
  colors: ['#E74C3C', '#F39C12', '#8E44AD'],
  labelsDiv: 'legendDivPM',
  labelsSeparateLines: false,
  legend: 'always',
  legendFormatter: makeLegendFormatter((data) => {
    return data
  }, true),
  animatedZooms: true
}

export {
  pmChartOptions
}